import React, {Component} from 'react';
import {Modal, Button, Icon, Header, Form, Message} from "semantic-ui-react";

class LoginModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            email:"",
            password:"",
            otp_attempt:"",
            errorMessage:false
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if(this.props.messages !== nextProps.messages){
            this.setState({errorMessage:true});
        }
    }

    errorMessage = () => {
        if (this.props.messages) {
            return (
                <Message size='mini' negative>
                    <Message.Header>Error Re-Logging In</Message.Header>
                    <p>{this.props.messages}</p>
                </Message>
            );
        }
    };

    render() {
        return (
            <div>
                <Modal closeOnDimmerClick={false} size="tiny" open={true} onClose={(e) => {
                    this.setState({errorMessage:false});
                }}>
                    <Modal.Content>
                        <Modal.Description>
                            <Header content="Re-Enter Email and Password"/>
                            <div>

                                {this.state.errorMessage && this.errorMessage()}
                                                                <Message warning><Message.Header>Session token has expired or is invalid. {<br/>} To continue further please re-enter your password</Message.Header><Message.Content><br/>Note: After re-login success, try the save button again. The confirm button below will not retry the save again, only validate the login </Message.Content></Message>
                            <Form onSubmit={() => {this.props.reLogin(this.state.email,this.state.password)}}>
                                <Form.Input name="login_email"   label="Email" type="email" onChange={(e) => {this.setState({email:e.target.value})}}/>
                                <Form.Input name="login_password"    label="Password"type="password" onChange={(e) => {this.setState({password:e.target.value})}}/>
                                <Form.Input label="OTP Code (ADMIN ONLY)" fluid icon='hash' iconPosition='left' placeholder='Six Digit Code from Authenticator App'
                                                            type='number'  name="otp_attempt" id="otp_attempt" onChange={(e) => {this.setState({otp_attempt:e.target.value})}}/>
                            </Form>
                            </div>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button content="Continue >>" disabled={this.props.reloggingin} loading={this.props.reloggingin} primary onClick={() => {this.props.reLogin(this.state.email, this.state.password,this.state.otp_attempt)}}/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

export default LoginModal;


// WEBPACK FOOTER //
// ./src/views/universal/login_modal.js